import { render, staticRenderFns } from "./Err.vue?vue&type=template&id=b485ff50&scoped=true&"
import script from "./Err.vue?vue&type=script&lang=js&"
export * from "./Err.vue?vue&type=script&lang=js&"
import style0 from "./Err.vue?vue&type=style&index=0&id=b485ff50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b485ff50",
  null
  
)

component.options.__file = "Err.vue"
export default component.exports